import { defineMessages } from 'react-intl';

const messages = defineMessages({
  openingStatement: {
    id: 'premium-menu.basic-info.openingStatement',
    defaultMessage: 'Opening Statement',
  },
  openingStatementSubtitle: {
    id: 'premium-menu.basic-info.openingStatementSubtitle',
    defaultMessage: '(The text will not display on the college profile if Intro/About Us content is added.)',
  },
  website: {
    id: 'premium-menu.basic-info.website',
    defaultMessage: 'Website',
  },
  campusSurroundings: {
    id: 'premium-menu.basic-info.campusSurroundings',
    defaultMessage: 'Campus Surroundings',
  },
  studentFacultyRatio: {
    id: 'premium-menu.basic-info.studentFacultyRatio',
    defaultMessage: 'Student / Faculty Ratio',
  },
  undergraduateWomen: {
    id: 'premium-menu.basic-info.undergraduateEnrollment.women',
    defaultMessage: 'Undergraduate Women',
  },
  undergraduateMen: {
    id: 'premium-menu.basic-info.undergraduateEnrollment.men',
    defaultMessage: 'Undergraduate Men',
  },
  gpaInvalidError: {
    id: 'premium-menu.basic-info.gpa.invalid',
    defaultMessage: 'GPA must be in n.n format. (Example: 3.0)',
  },
  // GPA
  25: {
    id: 'premium-menu.basic-info.gpa.25',
    defaultMessage: '25th Percentile (Visible only in SuperMatch)',
  },
  gpaInvalid25Error: {
    id: 'premium-menu.basic-info.gpa.invalid25',
    defaultMessage: 'This value must be less than or equal to Average',
  },
  50: {
    id: 'premium-menu.basic-info.gpa.50',
    defaultMessage: 'Average',
  },
  gpaInvalid50Error: {
    id: 'premium-menu.basic-info.gpa.invalid50',
    defaultMessage: 'This value must be less than or equal to 75th Percentile',
  },
  75: {
    id: 'premium-menu.basic-info.gpa.75',
    defaultMessage: '75th Percentile  (Visible only in SuperMatch)',
  },
  gpaInvalid75Error: {
    id: 'premium-menu.basic-info.gpa.invalid75',
    defaultMessage: 'This value must be greater than or equal to Average',
  },
  level: {
    id: 'premium-menu.basic-info.schoolType.level',
    defaultMessage: 'Level',
  },
  control: {
    id: 'premium-menu.basic-info.schoolType.control',
    defaultMessage: 'Control',
  },
  invalidError: {
    id: 'premium-menu.basic-info.testScores.invalid',
    defaultMessage: 'Invalid value.',
  },
  // Address
  applicationMailingAddress: {
    id: 'premium-menu.basic-info.address.applicationMailingAddress',
    defaultMessage: 'Application Mailing Address',
  },
  admissionsOffice: {
    id: 'premium-menu.basic-info.address.admissionsOffice',
    defaultMessage: 'Admissions Office',
  },
  financialAid: {
    id: 'premium-menu.basic-info.address.financialAid',
    defaultMessage: 'Financial Aid',
  },
  addressInvalidError: {
    id: 'premium-menu.basic-info.address.invalid',
    defaultMessage: 'Invalid value.',
  },
  country: {
    id: 'premium-menu.basic-info.address.country',
    defaultMessage: 'Country',
  },
  state: {
    id: 'premium-menu.basic-info.address.state',
    defaultMessage: 'State',
  },
  city: {
    id: 'premium-menu.basic-info.address.city',
    defaultMessage: 'City',
  },
  zip: {
    id: 'premium-menu.basic-info.address.zip',
    defaultMessage: 'ZIP',
  },
  street: {
    id: 'premium-menu.basic-info.address.street',
    defaultMessage: 'Street Address',
  },
  email: {
    id: 'premium-menu.basic-info.address.email',
    defaultMessage: 'Email address',
  },
  fax: {
    id: 'premium-menu.basic-info.address.fax',
    defaultMessage: 'Fax number',
  },
  phone: {
    id: 'premium-menu.basic-info.address.phone',
    defaultMessage: 'Phone number',
  },
  tollFreePhone: {
    id: 'premium-menu.basic-info.address.tollFreePhone',
    defaultMessage: 'Toll-free number',
  },
  url: {
    id: 'premium-menu.basic-info.address.url',
    defaultMessage: 'URL',
  },
  // Contact
  namePrefix: {
    id: 'premium-menu.basic-info.contact.namePrefix',
    defaultMessage: 'Name Prefix',
  },
  firstName: {
    id: 'premium-menu.basic-info.contact.firstName',
    defaultMessage: 'First Name',
  },
  middleName: {
    id: 'premium-menu.basic-info.contact.middleName',
    defaultMessage: 'Middle Name',
  },
  lastName: {
    id: 'premium-menu.basic-info.contact.lastName',
    defaultMessage: 'Last Name',
  },
  jobTitle: {
    id: 'premium-menu.basic-info.contact.jobTitle',
    defaultMessage: 'Job Title',
  },
  jobDescription: {
    id: 'premium-menu.basic-info.contact.jobDescription',
    defaultMessage: 'Job Description',
  },
  studentFacultyRatioInvalidError: {
    id: 'premium-menu.basic-info.studentFacultyRatio.invalid',
    defaultMessage: 'Invalid value.',
  },
});

export default messages;
